import React from "react";

import amrish from "../../assets/images/topimage.png";
import stethoscope from "../../assets/images/stethoscope.jpg";
const HomePageBanner = () => {
  return (
    <div
      className="w-full sm:h-[1500px] h-[1300px] lg:h-[1000px]  pt-[250px]   bg-transparent overflow-hidden flex justify-center relative"
      style={{
        backgroundImage: "linear-gradient(360deg, #D6ECE1 0%, #F2F2F2 100%)",
      }}
    >
      <div
        className="w-full absolute bottom-0 z-[2] -rotate-180 overflow-hidden"
        data-negative="false"
      >
        <svg
          className="h-[168px] transform "
          style={{
            width: "calc(111% + 1.3px)",
          }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
        >
          <path
            fill="#ffffff"
            class="elementor-shape-fill"
            d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
	c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
	c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"
          ></path>
        </svg>{" "}
      </div>
      <div
        className="bg-cover absolute inset-0 -top-40 opacity-25"
        style={{
          backgroundImage: `url(${stethoscope})`,
          backgroundPosition: "-25vw 2vh",
        
        }}
      ></div>
      <div className=" xl:w-[75%] z-10 w-full absolute top-24 lg:top-40  flex flex-col lg:flex-row justify-center ">
        <div className="lg:w-2/5 w-full flex flex-col pt-24 px-4">
          <p className="font-playfair sm:text-[72px] text-[60px] font-medium text-[#CFA649]">
            Refreshing
          </p>

          <h2 className="font-playfair sm:text-[72px] text-[60px] capitalize font-medium text-[#17543E]">
            body and soul
          </h2>
          <p className="text-[#000] font-medium text-lg font-raleway">
            Meet yourself where you are mindfulness balance, tadasana
            intentional. Namaste inhales, exhale reach expand open intentional
            Bikram intentional. Rinse deeper out of your comfort zone bandha
            self-care hug.
          </p>
          <div className="my-4">
            <button className="text-white bg-[#17543E] hover:opacity-80 transition-all hover:duration-200 border border-[#666] rounded-[50px] px-[45px] py-[10px] text-[19px] font-normal normal-case font-playfair">
              More Information
            </button>
          </div>
        </div>

        <div className="lg:w-3/5 w-full flex justify-center">
          <style>
            {`
    @keyframes float {
      0% { transform: translateY(0); }
      50% { transform: translateY(-15px); }
      100% { transform: translateY(0); }
    }
    .animate-float {
      animation: float 2.5s ease-in-out infinite;
    }
  `}
          </style>
          <img src={amrish} alt="banner" className="animate-float md:p-0 p-4" />
        </div>
      </div>
    </div>
  );
};

export default HomePageBanner;
